import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { AccordionEntry } from "frontend/contentful/schema/blocks";
import { Accordion } from "design-system/components/blocks/accordion/accordion";
import { createAccordionProps } from "./accordion.props";

export interface AccordionOptions {
  headerAbove?: boolean;
}

export const ContentfulAccordion = createContentfulComponent<
  AccordionEntry,
  AccordionOptions
>(({ entry, options }) => {
  const props = createAccordionProps(entry, options);

  return <Accordion {...props} />;
});
